import { Icon } from '@99designs/common/components/Icon';
import { Tooltip } from '@99designs/common/components/Tooltip';
import { FormattedMessage } from '@99designs/common/i18n';
import { Currency } from 'common/utils/currency';
import Price from 'projects/components/Price';
import React from 'react';
import styled from 'styled-components';

const TooltipContent = styled.div`
    max-width: 360px;
`;

const HelpIcon = styled.span`
    cursor: pointer;
    display: inline-block;
`;

function PriceGuide({ min, max, currency }: { min: number; max?: number; currency: Currency }) {
    const formattedPrices = () => {
        const formattedMin = <Price amount={min} currency={currency} />;

        if (!max) {
            return (
                <FormattedMessage message={__('from {amount}')} values={{ amount: formattedMin }} />
            );
        }

        return (
            <>
                <Price amount={min} currency={currency} />
                {' – '}
                <Price amount={max} currency={currency} />
            </>
        );
    };

    return (
        <p>
            {__('Price guide:')} {formattedPrices()}
            <Tooltip
                position={'up-left'}
                tooltip={
                    <TooltipContent>
                        {__(
                            'Based on the prices that designers typically quote for projects in this category.'
                        )}
                    </TooltipContent>
                }
            >
                <HelpIcon>
                    <Icon type={'question-mark-1'} variations={['offset-left']} />
                </HelpIcon>
            </Tooltip>
        </p>
    );
}

export default PriceGuide;
